<template>
	<!--specification-->
	<section class="content checkout-content p-0">
		<!--<seller-info-modal :vendorData="product.vpi">-->
		<!--</seller-info-modal>-->
		<div class="row">
			<div class="col-12 col-lg-4 p-0 mr-0">
				<div class="row sticky-product-img">
					<div class="wp_ProductSliderSingle_container" id="slider">
						<wishlist-action
							v-if="(product.vendor_product_inventories &&
												product.vendor_product_inventories[selectedVendorIndex])"
							:product="product"
						/>
						<image-detail-section
							:product="product"
							:outOfStock="outofStock"
							v-if="show"
						/>
						<div class="detail-slider" v-else>
							<mobile-image-slider
								:imageArray="product.product_details.images"
								:outOfStock="outofStock"
								:dots="true"
								:indexKey="product.product_id"
								v-if="product.product_details &&
																	product.product_details.images"
							/>
						</div>
					</div>

					<div class="col-12 order-1 order-xl-12 wp_ProductDetailsPageBuyButtons">
						<cart-action
							:is-add-to-cart="true"
							:is-buy-now="true"
							:pdp="true"
							:outOfStock="outofStock"
							v-if="product && product.product_id"
							:product="getSelectedProduct[0]"
							:vendor-id="product.vendor_id"
						/>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-8 pl-0 pt-3 pl-lg-4 pr-0 mr-0 pdp-filter-breadcrumb">
				<div class="row">
					<div class="cd-tab-filter">
						<div class="row">
							<div class="col-12 pl-0">
									<bread-crumb
											:productsLength="1"
											:productName="product.product_name"
											:from-pdp="true"
									/>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-9">
						<span data-test="productDetailsSectionPdtNameSpan"
												id="productDetailsSectionPdtNameSpan">
							<h5
								class="product-name-title"
								:id="'product-details-name-'+product.product_id"
								data-test="productDetailsSectionPdtName"
							>{{product.product_name}}</h5>
						</span>

						<!--Product Brand Container-->

						<span
							style="font-size: .7rem; text-decoration: none;"
							v-if="product.brand && product.brand.brand_name"
							data-test="productDetailsSectionBrandSpan"
							id="productDetailsSectionBrandSpan"
						>
							<h6 data-test="productDetailsSectionBrandHead"
											id="productDetailsSectionBrandHead">
								by
								<a
									class="pdp-brand"
									href
									v-if="product.brand.brand_logo"
									@click.prevent="brandProducts"
									data-test="productDetailsSectionBrandLink"
									id="productDetailsSectionBrandLink"
								>
									<img
										v-if="product.brand.brand_logo"
										:src="product.brand.brand_logo"
										alt
										data-test="productDetailsSectionBrandLogoImg"
										id="productDetailsSectionBrandLogoImg"
									/>
								</a>
								<a
									class="pdp-brand"
									href
									v-else
									@click.prevent="brandProducts"
									data-test="productDetailsSectionBrandName"
									id="productDetailsSectionBrandName"
								>{{product.brand.brand_name}}</a>
							</h6>
						</span>

						<!--Product Brand Container-->
					</div>
					<product-share :product="product"/>
					<!--{{product.review}}-->
					<div
						class="col-8 col-md-6 col-lg-4 prdt-rating-stars pr-0 mr-0"
						v-if="product.review && product.review.averageRating"
						:id="'product-details-rating-'+product.product_id"
						data-test="product-details-rating"
					>
						<star-rating
							v-model="product.review.averageRating"
							:show-rating="false"
							:read-only="true"
							:star-size="25"
							:increment=".1"
						/>
					</div>
					<div
						@click.stop="showReviewDiv"
						style="cursor: pointer"
						class="col-12 col-md-6 col-lg-8 mt-3 mt-md-0 rating-and-review"
						v-if="product && product.review &&
							product.review.productReviews &&
							product.review.productReviews.length"
						:id="'product-details-rate&review-'+product.product_id"
						data-test="productDetailsSectionPdtReview"
					>
						{{product.review.productReviews.length}} Ratings &
						{{product.review.productReviews.length}} Reviews
					</div>
					<div class="col-12 col-md-6 order-2 order-md-0">
						<div class="pdp-e-i-PAY-r disp-table-cell lfloat">
							<div class="pdpCutPrice pb-3">
								<meta itemprop="priceCurrency" content="INR"/>
							</div>
							<span
								class="pdp-final-price"
								v-if="product.promotion && product.promotion.promotion_id"
							>
								<span
									class="payBlkBig"
									itemprop="price"
									:id="'product-details-price-1-'+product.product_id"
									data-test="productDetailsSectionPdtPromoPrice"
								>{{product.promotion.promotion_applied_price | currencyConversion}}</span>
							</span>
							<span class="pdp-final-price" v-else>
								<span
									class="payBlkBig"
									itemprop="price"
									:id="'product-details-price-2'+product.product_id"
									v-if="product.vpi && product.vpi.price"
									data-test="productDetailsSectionPdtPrice"
								>{{product.vpi.price | currencyConversion}}</span>
							</span>
							<span class="pdpDiscount" v-if="product.promotion && product.promotion.promotion_id">
								<span
									:id="'product-details-percent'+product.product_id"
									data-test="productDetailsSectionPdtPromoPercent"
								>{{product.promotion.promotion_percentage}}</span>% OFF
							</span>
							<p
								class="og-price"
								v-if="product.promotion &&
								product.promotion.promotion_id &&
								product.vpi &&
								product.vpi.price"
								:id="'product-details-og-price'+product.product_id"
								data-test="productDetailsSectionPdtPrice2"
							>{{product.vpi.price | currencyConversion}}</p>
						</div>
						<promotion-section
							:promotionalPrice="product.promotions"
							:productId="product.product_id"
						/>
						<!--<div class="form-group row mt-3">-->
						<!--<label for="" class="col pt-2">Delivery</label>-->
						<!--<input type="text"  class="form-control col"
						aria-describedby="helpId"-->
						<!--placeholder="688530"-->
						<!--style="width:60%; border: none; border-bottom: solid 2px $accent-blue;">-->
						<!--</div>-->
					</div>
					<!--<div class="col-8 col-md-6 col-xl-4 mx-auto">-->
					<!--</div>-->
					<!-- Variants -->
					<variants-listing :product="product"/>
					<!-- Variants -->
					<div class="col-12 col-md-3"></div>
				</div>
				<div class="row">
					<div class="col-12 col-xl-6 order-12 order-xl-1">
						<ul
							class="nav prdt-list-styled pl-3 pt-3"
							v-if="(product && product.product_details &&
								product.product_details.details)"
						>
							<li
								class="nav-item"
								v-for="(desc,index) in product.product_details.details"
								:key="index"
							>
								<p
									:id="'product-details-'+index"
									:data-test="'productDetailsSectionDescription'+index"
								>{{desc}}</p>
							</li>
							<div class="sellerinfo">
								<span
									:id="'product-details-seller'+product.product_id"
									style="margin-top: .5rem"
									data-test="productDetailsSectionPdtSellerSpan"
								>Seller</span>
								<span
									v-if="product.vpi && product.vpi.vendor_name"
									:id="'product-details-vendor-'+product.product_id"
									data-toggle="modal"
									data-target="#sellerinfoModal"
									style="cursor: default;
										margin-top: .5rem;
										font-weight: 500;
										color: #2874f0;
										text-transform: capitalize"
									data-test="productDetailsSectionPdtVendorName"
								>{{product.vpi.vendor_name}}</span>
								<span
									v-else
									:id="'product-details-novendor-'+product.product_id"
									data-test="productDetailsSectionNoVendor"
								>Vendor information is not available.</span>
								<!--<div class="input-group mb-3">-->
								<!--<select-->
								<!--class="custom-select"-->
								<!--id="inputGroupSelect01"-->
								<!--v-model="selectedVendorIndex"-->
								<!--style="color: #00008b;font-weight: 600;font-size:16px;"-->
								<!--&gt;-->
								<!--<option-->
								<!--v-for="(vendor,index) in product.vendor_product_inventories"-->
								<!--:key="index"-->
								<!--:id="'vendor'+index"-->
								<!--:value="index"-->
								<!--&gt;-->
								<!--{{vendor.vendor_name}},-->
								<!--(Price : {{vendor.price | currencyConversion}})-->
								<!--</option>-->
								<!--</select>-->
								<!--</div>-->
							</div>
						</ul>
						<div
							v-if="(product && product.product_details &&
							product.product_details.short_description)"
						>
							<h5
								class="pt-4"
								:id="'product-details-description'+product.product_id"
								data-test="productDetailsSectionPdtDescTitle"
							>Product Description</h5>
							<p
								v-if="(product && product.product_details &&product.product_details.short_description)"
								:id="'product-details-shortdescription'+product.product_id"
								class="text-justify"
								data-test="productDetailsSectionPdtShortDesc"
							>{{product.product_details.short_description}}</p>
						</div>
					</div>
					<div class="col-12 col-xl-6 order-12 order-xl-2">
						<!--<shipping-charge-section />-->
						<vendor-listing-section
							:vendors="product.vendor_product_inventories"
							v-if="product.vendor_product_inventories && product.vendor_product_inventories.length > 1"
							:product="product"
							@showDeliveryAddressPickerPopUp="showDeliveryAddressPickerPopUp"
						/>
						<variant-product-listing-section
							:group-id="product.group_id"
							:product-id="product.product_id"
						/>
					</div>
				</div>

				<!-- specification -->
				<product-specification-section :product="productData"/>
				<!-- specification -->
				<!-- rating and review -->
				<product-rating-section :product="product" @commentReview="getProductDetails($event)"/>
				<!-- rating and review -->
			</div>
			<!--second row-->
			<delivery-address-popup
				v-if="deliveryAddressPickerPopUp"
				:customerAddress="getAddress"
				:product="product"
				@closeAddressPopUp="closeAddressPopUp($event)"
			/>
		</div>
	</section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StarRating from 'vue-star-rating'
import ProductShare from './share/ProductShare'
import VariantsListing from './variants/VariantsListing'
import PromotionSection from './promotion/PromotionSection'
import * as productApi from '../../../../services/ApiServices/productApi'
import MobileImageSlider from './imageContainer/mobile/MobileImageSlider'
import BreadCrumb from '../../../widgets/breadcrumb/BreadCrumb'
import ImageDetailSection from './imageContainer/imageDetailSection'
import VendorListingSection from './vendorList/VendorListingSection'
import VariantProductListingSection from './variants/sections/VariantProductListingSection'
import ProductSpecificationSection from './specifications/ProductSpecificationSection'
import ProductRatingSection from './rating/ProductRatingSection'
import DeliveryAddressPopup from './deliveryAddressPicker/DeliveryAddressPopup'
import WishlistAction from '../../../actions/wishlist/WishListAction'
import CartAction from '../../../actions/cart/CartAction'
// import ShippingChargeSection from './ShippingChargeSection'

export default {
	name: 'product-details-section',
	beforeDestroy () {
	},
	props: {
		productData: {},
		deliveryBasedVendorSelected: {
			type: Boolean,
			default: false
		}
	},
	mounted () {
		if (screen.width >= 992) {
			this.show = true
		}
		this.product = this.productData
		productApi.assignVendorInventoryAndPromotionalPrices(this.product)
		if (this.deliveryBasedVendorSelected) {
			this.assignVendorsBasedOnDelivery()
		}
	},
	data () {
		return {
			imageSelected: 0,
			selectedVendorIndex: 0,
			product: {},
			show: false,
			deliveryAddressPickerPopUp: false
		}
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		getProductDetails (productId) {
			this.$emit('commentReview', productId)
		},
		brandProducts () {
			this.$nextTick(() => {
				this.$router.push({
					name: 'BrandProducts',
					path: '/brand-products-list',
					query: {
						current_category_id: this.product.product_category_id,
						brand_id: this.product.brand.brand_id,
						display_text: this.product.brand.brand_name
					}
				})
			})
		},
		showDeliveryAddressPickerPopUp () {
			if (this.isAuthenticated) {
				this.deliveryAddressPickerPopUp = true
				this.$nextTick(() => {
					$('#DeliveryAddressPDPModal').modal('show')
				})
			} else {
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'previous'
					}
				})
			}
		},
		closeAddressPopUp (vendorSelected) {
			$('#DeliveryAddressPDPModal').modal('hide')
			this.deliveryAddressPickerPopUp = false
			if (vendorSelected) {
				this.assignVendorsBasedOnDelivery()
			}
		},
		assignVendorsBasedOnDelivery () {
			const vendorsList = []
			if (this.getAvailableVendors && this.getAvailableVendors.length > 0) {
				this.getAvailableVendors.forEach(vendorId => {
					this.getAllAvailableVendorInventories.forEach(vendor => {
						if (vendor.vendor_id === vendorId) {
							vendorsList.push(vendor)
						}
					})
				})
			}
			this.getSelectedProduct[0].vendor_product_inventories = vendorsList
		},
		showReviewDiv () {
			if (document.readyState === 'complete') {
				const reviewDiv = document.getElementById('showReview')
				const position = reviewDiv.offsetTop
				$('body, html').animate({
					scrollTop: position
				}, 500)
				this.$forceUpdate()
			}
		}
	},
	components: {
		// ShippingChargeSection,
		CartAction,
		WishlistAction,
		DeliveryAddressPopup,
		ProductRatingSection,
		ProductSpecificationSection,
		VariantProductListingSection,
		VendorListingSection,
		ImageDetailSection,
		BreadCrumb,
		MobileImageSlider,
		StarRating,
		// SellerInfoModal,
		ProductShare,
		// ProductPriceSection,
		VariantsListing,
		PromotionSection
		// OutOfStock,
		// VueZoom,
	},
	computed: {
		...mapGetters('productselected', [
			'getSelectedProduct',
			'getAvailableVendors',
			'getAllAvailableVendorInventories'
		]),
		...mapGetters('user', ['getAddress', 'isAuthenticated']),
		outofStock () {
			return (
				this.product.vendor_product_inventories &&
					this.product.vendor_product_inventories[this.selectedVendorIndex] &&
					this.product.vendor_product_inventories[this.selectedVendorIndex].available_stock < 1
			)
		},
		promotionalPrices () {
			const vpiData = this.product.vendor_product_inventories
			if (vpiData && vpiData[0]) {
				const promotions = vpiData[0].promotional_prices
				if (promotions && promotions.length > 0) {
					return promotions
				}
			}
			return []
		}
	},
	watch: {
		imageSelected () {
			const data3 = document.getElementsByClassName('zoomImg')
			if (data3 && data3.length > 0) {
				data3[0].remove()
			}
		},
		selectedVendorIndex: {
			handler (val) {
				// this.product.vpi = this.product.vendor_product_inventories[val];
				productApi.assignVendorInventoryAndPromotionalPrices(this.product, val)
				this.setSelectedProductData([this.product])
			},
			deep: true
		},
		productData: {
			handler (val) {
				this.product = this.productData
				productApi.assignVendorInventoryAndPromotionalPrices(
					this.product,
					this.selectedVendorIndex
				)
			},
			deep: true
		},
		deliveryBasedVendorSelected: {
			handler (val) {
				if (val) {
					this.assignVendorsBasedOnDelivery()
				}
			},
			deep: true
		}
	}
}
</script>
